import Airtable from "airtable";

const base = new Airtable({
    apiKey: "key8I0zvwzxlDYNj5",
}).base("appnh8J75D2UWDhWS");

export default base;